import React from "react";
import { Container } from "@mui/material";

import { Helmet } from "react-helmet-async";
import DisplaySurveys from "../sections/@dashboard/survey/DisplaySurveys";
import SurveyEvaluation from "../sections/@dashboard/survey/SurveyEvaluation";
import { Navigate, Route, Routes } from "react-router-dom";
import useAuth from "../hooks/useAuth";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

const SurveyPage = () => {
  const { isMember } = useAuth();

  return (
    <>
      <Helmet>
        <title> Dashboard | Befragung </title>
      </Helmet>

      <Container maxWidth={""}>
        <Routes>
          <Route index element={<DisplaySurveys />} />
          <Route
            path="evaluate/:surveyId"
            element={isMember ? <Navigate to="/dashboard/survey" replace /> : <SurveyEvaluation />}
          />
        </Routes>
      </Container>
    </>
  );
};

export default SurveyPage;
